<form [formGroup]="formCard" class="space-y-5">
  <h1 class="text-vivid-royal-500 dark:text-dark-khaki-50 text-lg md:text-xl">Datos de Unidad</h1>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Nombre de Usuario</label>
      <input pInputText formControlName="user" class="w-full mt-1" />
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Descripción <span class="text-vivid-royal-400 font-normal">(opcional)</span></label>
      <input pInputText formControlName="description" class="w-full mt-1" />
    </div>

    @if (!hidePlates) {
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Placa Principal <span class="text-mustard-500">*</span></label>
        <div class="relative mt-1">
          <input pInputText formControlName="plate1" (keyup)="validatePlates($event)" id="plate1"
            [inputTransformFn]="inputTransformFn" [outputTransformFn]="outputTransformFn"
            [dropSpecialCharacters]="false" [patterns]="pattern" [specialCharacters]="['-']"
            mask="K?K?K?K?K?K?K?K?K?K?" class="w-full uppercase" />
        </div>
        @if(plate1.disabled && messagePlacas) {
          <small class="flex items-center gap-1.5 mt-1.5 px-2.5 py-1.5 rounded-md bg-mustard-100 border border-mustard-300 text-mustard-800 dark:bg-mustard-900/30 dark:border-mustard-700 dark:text-mustard-300 text-xs">
            <i class="pi pi-exclamation-triangle text-sm"></i> {{ messagePlacas }}
          </small>
        }
        @if(plate1.errors?.['required'] && plate1.touched) {
          <small class="text-red-500">La placa principal es requerida</small>
        }
        @if(plate1.errors?.['mask'] && plate1.touched) {
          <small class="text-red-500">El formato de placa no es válido</small>
        }
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Placa Secundaria <span class="text-vivid-royal-400 font-normal">(opcional)</span></label>
        <div class="relative mt-1">
          <input pInputText formControlName="plate2" (keyup)="validatePlates($event)" id="plate2"
            [inputTransformFn]="inputTransformFn" [outputTransformFn]="outputTransformFn"
            [dropSpecialCharacters]="false" [patterns]="pattern" [specialCharacters]="['-']"
            mask="K?K?K?K?K?K?K?K?K?K?" class="w-full uppercase" />
        </div>
        @if(plate2.disabled && messagePlacas) {
          <small class="flex items-center gap-1.5 mt-1.5 px-2.5 py-1.5 rounded-md bg-mustard-100 border border-mustard-300 text-mustard-800 dark:bg-mustard-900/30 dark:border-mustard-700 dark:text-mustard-300 text-xs">
            <i class="pi pi-exclamation-triangle text-sm"></i> {{ messagePlacas }}
          </small>
        }
      </div>
    }

    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Departamento <span class="text-vivid-royal-400 font-normal">(opcional)</span></label>
      <input pInputText formControlName="department" class="w-full mt-1" />
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Último Odómetro Reportado</label>
      <input pInputText formControlName="lastOdometer" class="w-full mt-1" [readonly]="true" />
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Número económico del vehículo <span class="text-vivid-royal-400 font-normal">(opcional)</span></label>
      <input pInputText formControlName="ecoNum" class="w-full mt-1" />
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Cuenta Contable <span class="text-vivid-royal-400 font-normal">(opcional)</span></label>
      <input pInputText formControlName="account" class="w-full mt-1" />
    </div>
  </div>

  @if(showMessageError) {
    <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ messagesError }}</div>
  }

  @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
    <div class="flex justify-end">
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-sm" type="button"
        [disabled]="formCard.invalid || showMessageError" (click)="showConfirmDialog()"></button>
    </div>
  }
</form>

<p-dialog header="Confirmar cambios" [(visible)]="showConfirm" [modal]="true" [style]="{width: '400px'}">
  <p class="text-sm" [innerHTML]="messageConfirm"></p>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showConfirm=false"></button>
    <button pButton label="Aceptar" (click)="showConfirm=false; saveCardData()"></button>
  </ng-template>
</p-dialog>
